import { render, staticRenderFns } from "./PostMessages.vue?vue&type=template&id=372a4166&scoped=true"
import script from "./PostMessages.vue?vue&type=script&lang=js"
export * from "./PostMessages.vue?vue&type=script&lang=js"
import style0 from "./PostMessages.vue?vue&type=style&index=0&id=372a4166&prod&lang=css"
import style1 from "./PostMessages.vue?vue&type=style&index=1&id=372a4166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372a4166",
  null
  
)

export default component.exports